const ENV_PREFIX = 'VUE_APP_'

function read(name, fallback = '') {
    const value = process.env[`${ENV_PREFIX}${name}`]
    return value === undefined || value === '' ? fallback : value
}

function readRequired(name) {
    const value = read(name)

    if (!value) {
        throw new Error(`Missing required environment variable: ${ENV_PREFIX}${name}`)
    }

    return value
}

function readPositiveInteger(name, fallback) {
    const rawValue = read(name, String(fallback))
    const value = Number.parseInt(rawValue, 10)

    if (!Number.isInteger(value) || value <= 0) {
        throw new Error(`${ENV_PREFIX}${name} must be a positive integer`)
    }

    return value
}

function buildAuthUrl() {
    const authUrl = new URL(readRequired('AUTH_BASE_URL'))

    authUrl.searchParams.set('client_id', readRequired('AUTH_CLIENT_ID'))
    authUrl.searchParams.set('response_type', 'code')
    authUrl.searchParams.set('grant_type', 'authorization_code')
    authUrl.searchParams.set('redirect_uri', readRequired('AUTH_REDIRECT_URI'))
    authUrl.searchParams.set('state', window.location.origin)

    return authUrl.toString()
}

function buildBasicAuthorization(username, password) {
    return username && password ? `Basic ${window.btoa(`${username}:${password}`)}` : ''
}

const ptvUser = read('PTV_USER', 'xtok')
const ptvPassword = read('PTV_PASSWORD')
const ptvAuthorization = buildBasicAuthorization(ptvUser, ptvPassword)

const environment = Object.freeze({
    ENV_NAME: read('ENV_NAME', process.env.NODE_ENV),
    GOLIA_API: readRequired('GOLIA_API'),
    GOLIA_CORE_URL: readRequired('GOLIA_CORE_URL'),
    GOLIA_EXCHANGE_API: readRequired('GOLIA_EXCHANGE_API'),
    GOLIA_EXCHANGE_LOGIN_TOKEN: read('GOLIA_EXCHANGE_LOGIN_TOKEN'),
    SIMULATOR_SERVER_HOST: readRequired('SIMULATOR_SERVER_HOST'),
    AUTH_20_LINK: buildAuthUrl(),
    REVERSE_GEOCODING_URL: readRequired('REVERSE_GEOCODING_URL'),
    REVERSE_GEOCODING_AUTHORIZATION: read(
        'REVERSE_GEOCODING_AUTHORIZATION',
        ptvAuthorization
    ),
    PTV_AUTHORIZATION: ptvAuthorization,
    ptv_user: ptvUser,
    ptv_password: ptvPassword,
    PLATE_TRUNCATE_LENGTH: readPositiveInteger('PLATE_TRUNCATE_LENGTH', 10)
})

export default environment
